import type { ProspectInDetails } from "@/models/ProspectInDetails";
import type { Axios } from "axios";
import type { UseQueryOptions } from "@tanstack/react-query";

export const getProspectById = async (
  axiosInstance: Axios,
  prospectId: number
): Promise<ProspectInDetails> => {
  try {
    const response = await axiosInstance.get<ProspectInDetails>(
      `/prospects/${prospectId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching prospect:", error);
    throw error;
  }
};

export const getProspectByIdQuery = (
  axiosInstance: Axios,
  prospectId: number
): UseQueryOptions<ProspectInDetails | undefined> => ({
  queryKey: ["prospect", prospectId],
  queryFn: () => getProspectById(axiosInstance, prospectId)
});
